enum OpportunityQuickFilter {
  ARCHIVED = 'archived',
  CAMPAIGN_ID = 'campaign_id',
  CONFIDENCE_LEVEL_IDS = 'confidence_level_ids',
  OPPORTUNITY_LABEL_IDS = 'opportunity_label_ids',
  OPPORTUNITY_STAGE_IDS = 'opportunity_stage_ids',
  OWNER_IDS = 'owner_ids',
}

export default OpportunityQuickFilter;
